import { buildTypedMap } from '../types/TypedMap';
import { DEAL_SPLITS_ENABLED, FISCAL_OFFSET, HAS_SETUP_FORECAST_CATEGORIES, STALE_SUBMISSION_FORECAST } from '../constants/SettingsTypes';
import { FETCH_PORTAL_SETTINGS_SUCCEEDED, FETCH_PORTAL_SETTINGS_STARTED } from '../actions/ActionTypes';
import { STARTED, SUCCEEDED, UNINITIALIZED } from '../constants/RequestStatusTypes';
const initialState = buildTypedMap({
  status: UNINITIALIZED,
  [DEAL_SPLITS_ENABLED]: false,
  [FISCAL_OFFSET]: null,
  [STALE_SUBMISSION_FORECAST]: null,
  [HAS_SETUP_FORECAST_CATEGORIES]: false
});
export default function portalSettings(state = initialState, action) {
  switch (action.type) {
    case FETCH_PORTAL_SETTINGS_STARTED:
      return state.merge({
        status: STARTED
      });
    case FETCH_PORTAL_SETTINGS_SUCCEEDED:
      {
        return state.merge({
          status: SUCCEEDED
        }).merge(action.payload);
      }
    default:
      return state;
  }
}